import { RouteComponentProps } from "react-router-dom"
import { IOptionsAccess } from "interfaces/IUser"
import { getValueShippinggroupStatusEnum } from "./UtilsHelper"
import { ResourceRoleEnum } from "enums/ResourceRoleEnum"
import { matchPath } from "react-router-dom"

/**
 * This function validates the accesses that the user has to access certain routes, and returns no true or false whether or not he has access to this route.
 * @param param0 {String}. It receives a match which are the props of the String type component.
 * @param optionsMenuAcces {Array} receives an array of access options.
 * @returns {Boolean}.
 */

export const validateAccessRouteOrder = (
  { match }: RouteComponentProps<{ type: string }>,
  optionsMenuAcces?: Array<IOptionsAccess>,
): boolean => {
  const status = getValueShippinggroupStatusEnum(match.params.type)

  if (!status) return false

  // TODO: these paths don't exist in optionsMenuAcces which blocks access to the page they're forced to display with this, this needs refactoring.
  const customRoutes = [
    "pickup_in_my_source",
    "transit_to_source"
  ]

  return optionsMenuAcces
    ? optionsMenuAcces.some(({ statusOrder }) => {
      if (customRoutes.includes(match?.params?.type)) return true
      return statusOrder === status
    })
    : false
}

/**
 * Lista de rutas restringidas para usuarios con rol webapp-contractor-source
 * Estos usuarios serán redirigidos a /contractor/dashboard si intentan acceder a estas rutas
 */
export const CONTRACTOR_SOURCE_RESTRICTED_ROUTES = [
  "/",
  "/dashboard",
  "/order/:type",
  "/order/confirmation/:shippingGroupId/:id",
  "/order/package/:shippingGroupId/:id",
  "/order/delivery/:shippingGroupId/:id",
  "/order/transit/:shippingGroupId/:id",
  "/order/in_source_preparation/:shippingGroupId/:id",
  "/order/in_transit_for_reception/:shippingGroupId/:id",
  "/order/in_transit_for_reception_opl/:shippingGroupId/:id",
  "/order/return_in_review/:shippingGroupId/:id",
  "/order/pickup/:shippingGroupId/:id",
  "/order/delivered/:shippingGroupId/:id",
  "/order/closed/:shippingGroupId/:id",
  "/order/in_return/:shippingGroupId/:id",
  "/order/returned/:shippingGroupId/:id",
  "/order/canceled/:shippingGroupId/:id",
  "/order/rejected/:shippingGroupId/:id",
  "/search/:query/:optionFilter",
  "/report",
  "/page/transfer",
  "/page/manifest",
]

/**
 * Verifica si una ruta está restringida para un rol específico
 * @param pathname {string} La ruta actual que se está intentando acceder
 * @param userRole {string} El rol del usuario actual
 * @returns {boolean} true si la ruta está restringida para ese rol
 */
export const isRestrictedRouteForRole = (
  pathname: string,
  userRole: string
): boolean => {
  // Solo aplicar restricciones para el rol webapp-contractor-source
  if (userRole !== ResourceRoleEnum["webapp-contractor-source"]) {
    return false
  }

  // Verificar si la ruta actual coincide con alguna ruta restringida
  return CONTRACTOR_SOURCE_RESTRICTED_ROUTES.some(restrictedRoute => {
    const match = matchPath(pathname, {
      path: restrictedRoute,
      exact: true,
      strict: false
    })
    return match !== null
  })
}
